document.addEventListener(
	'focus',
	e => {
		if (
			e.target.tagName === 'INPUT' &&
			e.target.hasAttribute('data-select-content')
		) {
			e.target.select();
		}
	},
	true,
);
